export const project = 'cdl'; // need this for when we dynamically import utils

/**
 * Cleaning up data to format it the way CDL should be
 *
 * @param {Object} data - The data object to clean
 */
const removeSelectFalsyKeys = (data) => {
	// IMPORTANT: We only want to remove empty objects, null, or undefined. We do not want to remove empty strings nor zeroes.
	const cleanedData = {};

	const isEmptyObj = (obj) =>
		typeof obj === 'object' &&
		obj !== null &&
		Object.keys(obj).length === 0;

	const cleanValue = (value) => {
		// Remove null, undefined, or empty objects
		if (value === null || value === undefined || isEmptyObj(value)) {
			return undefined;
		}

		// Recursively clean nested objects
		if (
			typeof value === 'object' &&
			value !== null &&
			!Array.isArray(value)
		) {
			const cleaned = {};
			Object.entries(value).forEach(([nestedKey, nestedValue]) => {
				const cleanedNestedValue = cleanValue(nestedValue);
				if (cleanedNestedValue !== undefined) {
					cleaned[nestedKey] = cleanedNestedValue;
				}
			});
			return Object.keys(cleaned).length > 0 ? cleaned : undefined;
		}

		return value;
	};

	Object.entries(data).forEach(([key, value]) => {
		const cleanedValue = cleanValue(value);
		if (cleanedValue !== undefined) {
			cleanedData[key] = cleanedValue;
		}
	});

	return cleanedData;
};

/**
 * Sending function for CDL project
 * Pushes payloads to window.coxAutoDataLayer
 *
 * @param {Object} params - Parameters object
 * @param {Window} params.win - The window object
 * @param {Object} params.data - The payload to send
 * @param {boolean} params.preview - Whether in preview mode
 */
export const sending = ({ win, data, preview }) => {
	const payload = removeSelectFalsyKeys(data);
	const reportsForEventViewer = [];
	const reportsForNewRelic = [];

	if (!preview) {
		// Push to coxAutoDataLayer
		win.coxAutoDataLayer.push(payload);
	}

	const sender = 'coxAutoDataLayer';

	reportsForEventViewer.push({
		clientEventName: payload?.event?.category || 'cdl_event',
		payload,
		sender
	});

	reportsForNewRelic.push({
		clientEventName: payload?.event?.category || 'cdl_event',
		sender
	});

	return {
		reportsForEventViewer,
		reportsForNewRelic
	};
};
